import templateUrl from './planning-resources-census-data.html';
import times from 'lodash/times';
import findIndex from 'lodash/findIndex';
import find from 'lodash/find';
import head from 'lodash/head';

import Highcharts from 'highcharts';
require('highcharts/modules/map')(Highcharts);

export const planningResourcesCensusDataComponent = {
    templateUrl,

    bindings: {
        data: '<'
    },

    controller: class PlanningResourcesCensusDataComponent {
        constructor(HighmapsService, CensusDataMapService, $scope, $timeout) {
            'ngInject';

            this.highmapsService = HighmapsService;
            this.censusDataMapService = CensusDataMapService;
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.mapData = this.highmapsService.getCountyData();
            this.colors = ['#668de5', '#f5a36f', '#ed6d79', '#66d18a', '#90d4f7'];
        }

        /**
         * Initial loading of Highmap
         */
        $onInit() {
            this.backButtonEnabled = false;
            this.selectedButtonId = 1;
            this.selectedId = this.selectedId || head(this.data.fiscalYear).id;
            this.censusDataMapService.getCensusFilterData(this.selectedId).then((details) => {
                this.data.censusData.countyData = angular.copy(details.censusData.countyData);

                const selectedButtonIndex = findIndex(this.data.filter, { isSelected: true });

                if (this.data.censusData.countyData.length > 0) {
                    this.$timeout(() => {
                        this.loadMap(this.data.censusData.countyData, this.data.filter[selectedButtonIndex].id);
                    }, 100);
                }
            });
        }

        /**
         * Filter function on fiscal year change
         */
        onFiscalYearChange(id) {
            this.censusDataMapService.getCensusFilterData(id).then((details) => {
                this.data.censusData.countyData = angular.copy(details.censusData.countyData);

                const selectedButtonIndex = findIndex(this.data.filter, { isSelected: true });

                if (this.data.censusData.countyData.length > 0) {
                    this.$timeout(() => {
                        this.loadMap(this.data.censusData.countyData, this.data.filter[selectedButtonIndex].id);
                    }, 100);
                }
            });
        }

        /**
         * show highmap data based on owner, renter or all button selected
         */
        buttonSelected(id) {
            this.data.filter.map((button) => {
                return button.isSelected = (button.id === id) ? true : false;
            });
            this.selectedButtonId = id;
            if (this.data.censusData.countyData.length > 0) {
                this.$timeout(() => {
                    this.loadMap(this.data.censusData.countyData, id);
                }, 100)
            }
        }

        /**
         * get dynamic range for highmap based on button selected
         * @param  [array] data   [highmap county data]
         * @param  [array] colors [colors for counties on highmap]
         * @return {[array]}        [dataClasses array for highmap legend]
         */
        getDataRange(data, colors) {
            const maxValue = data.reduce((max, curr) => {
                if (curr.value > max) {
                    max = curr.value;
                }
                return max;
            }, 0);
            return times(5, _getRange);

            function _getRange(index) {
                let obj = {
                    color: colors[index]
                }
                if (index !== 0) {
                    obj.from = index === 0 ? Math.round(maxValue / 5) : Math.round(maxValue / 5 * (index)) + 1;
                }
                if (index !== 4) {
                    obj.to = index !== 4 ? Math.round(maxValue / 5 * (index + 1)) : Math.round((maxValue / 5 * index) + 1);
                }
                return obj;
            }

        }

        /**
         * get map details object with hc-key and values based on owner, renter or all button selected
         * @param  [array] data [county data]
         * @param  {number} id   [button id selected]
         * @return [array]      [array with values and hc-key]
         */

        getMapdata(data, id) {
            return data.map((value) => {
                let obj = {
                    'name': value.name,
                    'ownerOccupied': value.ownerOccupied,
                    'renterOccupied': value.renterOccupied
                }
                if (id === 1) {
                    obj.value = value.ownerOccupied.noVehicle + value.ownerOccupied.oneVehicle + value.renterOccupied.noVehicle + value.renterOccupied.oneVehicle;
                }
                if (id === 2) {
                    obj.value = value.ownerOccupied.noVehicle + value.ownerOccupied.oneVehicle;
                }
                if (id === 3) {
                    obj.value = value.renterOccupied.noVehicle + value.renterOccupied.oneVehicle;
                }

                return obj;
            });
        }

        getMapdataProcess(mapDetails, dataClasses) {
            const colors = this.colors;
            let dataClassesArr = dataClasses.reduce((arr, value, index) => {
                let obj = {
                    name: '',
                    color: value.color,
                    data: []
                };
                if (value.hasOwnProperty('from') && value.hasOwnProperty('to')) {

                    obj.name = `${_getNumberFormat(value.from)} - ${_getNumberFormat(value.to)}`;
                } else if (value.hasOwnProperty('to') && !value.hasOwnProperty('from')) {
                    obj.name = `< ${_getNumberFormat(value.to)}`;
                } else if (value.hasOwnProperty('from') && !value.hasOwnProperty('to')) {
                    obj.name = `> ${_getNumberFormat(value.from)}`;
                }
                obj.data = _getMapdata(mapDetails, value, value.color);
                if (obj.data.length > 0) {
                    arr.push(obj);
                }
                return arr;
            }, []);

            if (mapDetails.length !== this.mapData.features) {
                let obj = {
                    name: 'No Data Available',
                    color: '#bcbcbd',
                    data: _getNotAvailableCountyData(mapDetails, this.mapData.features)
                };
                dataClassesArr.unshift(obj);
            }
            return dataClassesArr;

            function _getNotAvailableCountyData(data, highmapData) {
                return highmapData.reduce((arr, value) => {
                    const index = findIndex(data, ['name', value.properties.name]);
                    if (index === -1) {
                        arr.push({
                            color: "#bcbcbd",
                            name: value.properties.name,
                            ownerOccupied: _getNotavailbleValue(),
                            renterOccupied: _getNotavailbleValue(),
                            value: undefined
                        })
                    }
                    return arr;
                }, [])
            }
            function _getNotavailbleValue() {
                return {
                    noVehicle: "N/A",
                    oneVehicle: "N/A"
                }
            }
            function _getMapdata(details, range, color) {
                return details.reduce((data, county) => {
                    if (range.hasOwnProperty('from') && range.hasOwnProperty('to')) {
                        if (county.value > range.from && county.value < range.to) {
                            county.color = color;
                            data.push(county);
                        }
                    } else if (range.hasOwnProperty('to') && !range.hasOwnProperty('from')) {
                        if (county.value < range.to) {
                            county.color = color;
                            data.push(county);
                        }
                    } else if (range.hasOwnProperty('from') && !range.hasOwnProperty('to')) {
                        if (county.value > range.from) {
                            county.color = color;
                            data.push(county);
                        }
                    }
                    return data;
                }, [])
            }

            function _getNumberFormat(data) {
                return Highcharts.numberFormat(data, 0).replace(/ /g, ',')
            }
        }

        chartRedraw() {
            var id = find(this.data.filter, { isSelected: true }).id;
            this.loadMap(this.data.censusData.countyData, id);
        }

        /**
         * render highmap
         * @param  [array] data [county data]
         * @param  {number} id   [button id selected]
         * @return       loads map
         */
        loadMap(data, id) {
            this.backButtonEnabled = false;
            var seriesIndex = '';
            let mapDetails = this.getMapdata(data, id);
            let dataClasses = this.getDataRange(mapDetails, this.colors);
            let mapDataProcess = this.getMapdataProcess(mapDetails, dataClasses);
            const ownerTooltip = `
                <div class="owner-data">
                    <h4>Owner Occupied</h4>
                    <div class="owner-no-vehicle">
                        <p>No Vehicle</p>
                        <span>{point.ownerOccupied.noVehicle}</span>
                    </div>
                    <div class="owner-one-vehicle">
                        <p>1 Vehicle</p>
                        <span>{point.ownerOccupied.oneVehicle}</span>
                    </div>
                </div>
            `;

            const renterTooltip = `
                <div class="renter-data">
                    <h4>Renter Occupied</h4>
                    <div class="renter-no-vehicle">
                        <p>No Vehicle</p>
                        <span>{point.renterOccupied.noVehicle}</span>
                    </div>
                    <div class="renter-one-vehicle">
                        <p>1 Vehicle</p>
                        <span>{point.renterOccupied.oneVehicle}</span>
                    </div>
                </div>
            `;

            // Initiate the chart
            let map = angular.element(document.getElementById('county-map'));

            Highcharts.mapChart('county-map', {
                chart: {
                    height: 600,
                    backgroundColor: null
                },
                title: {
                    text: ''
                },
                subtitle: {
                    text: ''
                },
                // colors: this.colors,
                legend: _getLegendConfig(),
                tooltip: _getTooltipConfig(),
                credits: {
                    enabled: false
                },
                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 567
                        },
                        chartOptions: {
                            chart: {
                                height: 300
                            },
                            legend: _getResponsiveLegendConfig(),
                            plotOptions: {
                                map: {
                                    dataLabels: _getResponsiveDataLabelsConfig()
                                }
                            }
                        }
                    }]
                },
                plotOptions: {
                    map: {
                        allAreas: false,
                        mapData: this.mapData,
                        borderColor: '#fff',
                        borderWidth: 3,
                        cursor: 'pointer',
                        joinBy: ["name"],
                        dataLabels: _getDataLabelsConfig(),
                        allowPointSelect: true,
                        point: _getPointEvent.call(this),
                        states: {
                            select: {
                                color: this.colors[seriesIndex],
                                enabled: true
                            }
                        }

                    },
                    series: {
                        events: {
                            legendItemClick: (e) => {
                                return false;
                            }
                        }
                    }
                },
                // colorAxis: { dataClasses: dataClasses },
                series: mapDataProcess
            });

            function _getResponsiveDataLabelsConfig() {
                return {
                    style: {
                        color: '#fff',
                        fontSize: "8px",
                        fontFamily: "Myriad Pro Regular",
                        fontWeight: "700",
                        textOutline: ""
                    }
                }
            }

            function _getDataLabelsConfig() {
                return {
                    enabled: true,
                    className: "data-label",
                    format: '{point.name}',
                    style: {
                        color: '#fff',
                        fontSize: "11px",
                        fontFamily: "Myriad Pro Regular",
                        fontWeight: "700",
                        textOutline: ""
                    }
                }
            }


            function _getZoomDataLabelsConfig() {
                return {
                    style: {
                        fontSize: "20px"
                    }
                }
            }

            function _getPointEvent() {
                return {
                    events: {
                        // click: (e) => {

                        // },
                        select: (e) => {
                            var countyIndex = e.target.index;
                            seriesIndex = e.target.series.index;

                            e.target.series.chart.series.map((val, index) => {
                                val.update({ data: _setSelectedCounty(val.data, seriesIndex, index) })
                                return val;
                            });

                            function _setSelectedCounty(data, seriesIndex, currentIndex) {
                                return data.map((value, index) => {
                                    if (index === countyIndex && seriesIndex === currentIndex) {
                                        value.visible = true;
                                        value.selected = true;
                                        value.dataLabels = _getZoomDataLabelsConfig();
                                    } else {
                                        value.visible = false;
                                        value.setVisible(false, false);
                                        value.selected = false;
                                    }
                                    return value
                                })
                            }
                            this.$scope.$apply(() => {
                                this.backButtonEnabled = true;
                            })
                            e.target.zoomTo();
                        }
                    }
                }
            }

            function _getTooltipConfig() {
                return {
                    backgroundColor: 'rgba(255, 255, 255, .98)',
                    borderWidth: 0,
                    headerFormat: '<h3 class="county-title">{point.key} county</h3>',
                    useHTML: true,
                    padding: 10,
                    shadow: true,
                    pointFormat: id === 1 ? ownerTooltip + renterTooltip : id === 2 ? ownerTooltip : id === 3 ? renterTooltip : ''
                }
            }

            function _getResponsiveLegendConfig() {
                return {
                    title: {
                        style: {
                            fontSize: "13px"
                        }
                    },
                    layout: 'horizontal',
                    align: 'center',
                    verticalAlign: 'bottom',
                    itemMarginBottom: 5,
                    itemMarginTop: 10,
                    itemStyle: {
                        color: "#404041",
                        fontSize: "13px",
                        fontWeight: "400",
                        fontFamily: "Myriad Pro Regular"
                    }
                }
            }

            function _getLegendConfig() {
                return {
                    title: {
                        text: 'Number of Transportation Disadvantaged Residents',
                        style: {
                            color: "#404041",
                            fontSize: "16px",
                            fontWeight: "400",
                            fontFamily: "Myriad Pro Semibold"
                        }
                    },
                    layout: 'horizontal',
                    align: 'left',
                    verticalAlign: 'bottom',
                    itemMarginBottom: 10,
                    itemMarginTop: 20,
                    itemStyle: {
                        color: "#404041",
                        fontSize: "16px",
                        fontWeight: "400",
                        fontFamily: "Myriad Pro Regular"
                    },
                    floating: false,
                    valueDecimals: 0,
                    symbolRadius: 0,
                    symbolPadding: 15,
                    symbolHeight: 20
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/planning-resources-census-data/planning-resources-census-data.component.js